import { render, staticRenderFns } from "./RecentTransactions.vue?vue&type=template&id=7f4e6bfa&scoped=true"
import script from "./RecentTransactions.vue?vue&type=script&lang=js"
export * from "./RecentTransactions.vue?vue&type=script&lang=js"
import style0 from "./RecentTransactions.vue?vue&type=style&index=0&id=7f4e6bfa&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4e6bfa",
  null
  
)

export default component.exports